// extracted by mini-css-extract-plugin
export var contents_wrapper = "contents-module--contents_wrapper--91bc1";